import axios from "axios";
import {
  rolesRequested,
  rolesRequestSucceeded,
  rolesRequestFailed,
} from "../slices/GetRolesByCountrySlice";

const selectedCountry = localStorage.getItem("selectedCountry");

const apiUrl = `${process.env.REACT_APP_BASE_API_URL}/api/Rol`;

const ApiKey = process.env.REACT_APP_BASE_API_KEY;

const getSelectedCountryId = () => {
  const sessionData = localStorage.getItem("sesion");

  if (!sessionData || !selectedCountry) {
    return null;
  }

  const session = JSON.parse(sessionData);
  const country = (session.rols || [])
    .map((entry) => entry.country)
    .find((item) => item?.countryName === selectedCountry);

  return country?.idcountry ?? null;
};

export const getRolesByCountry = () => async (dispatch) => {
  try {
    dispatch(rolesRequested());

    const axiosConfig = {
      headers: {
        ApiKey: ApiKey,
        "Content-Type": "application/json",
      },
    };

    const response = await axios.get(apiUrl, axiosConfig);
    const countryId = getSelectedCountryId();

    const filteredRoles = (response.data || []).filter((role) => {
      const roleCountryId = role.country?.idcountry ?? role.country?.idCountry;

      if (countryId == null) {
        return true;
      }

      return Number(roleCountryId) === Number(countryId);
    });

    dispatch(rolesRequestSucceeded(filteredRoles));
  } catch (error) {
    dispatch(rolesRequestFailed(error.message));
  }
};
